import { Spinner as Spinner$1 } from '@shopify/ui-extensions/checkout';
import { createRemoteReactComponent } from '@remote-ui/react';

const Spinner = createRemoteReactComponent(Spinner$1);

export { Spinner };
